import { type Association } from "@entities";
import { type ColumnProps } from "@shared/frontend/hyper-table/types";
import UserNameAndPhoto from "../users-table/volunteers/components/UserNameAndPhoto";
import PhoneNumberCell from "../PhoneNumberCell";

export const columns: ColumnProps<Association>[] = [
  {
    field: "user.name",
    caption: "שם מלא",
    enableSorting: true,
    cell: ({ row }) => {
      return <UserNameAndPhoto user={row.original.user} />;
    },
  },
  {
    field: "user.phoneNumber",
    caption: "טלפון",
    cell: ({ row }) => (
      <PhoneNumberCell phoneNumber={row.original.user?.phoneNumber || ""} />
    ),
    preventRowClick: true,
  },
  {
    field: "user.numberID",
    caption: "מספר זהות",
  },
  {
    field: "user.email",
    caption: "דואר אלקטרוני",
  },
  {
    field: "user.dateOfBirth",
    caption: "תאריך לידה",
    valueConverter: (row) => {
      const dob = row.user?.dateOfBirth;
      if (!dob) return "-";
      return new Date(dob).toLocaleDateString("he");
    },
  },
  {
    field: "user.skills.skill.name",
    caption: "כישורים",
    valueConverter: (row) => {
      return row.user?.skills?.map((skill) => skill.skill?.name)?.join(" ,") || "-";
    },
  },
  {
    field: "user.gender",
    caption: "מגדר",
    valueConverter: (row) => {
      const gender = row.user?.gender;
      if (gender === "MALE") return "זכר";
      if (gender === "FEMALE") return "נקבה";
      if (gender === "OTHER") return "אחר";
      return "-";
    },
  },
];

export default columns;
